<template>
<div id="app">
  <!--banner-->
  <div class='banner'>
    <div class='main'>
      <h1><a href="javascript:;" class='logo tx_indent'>迷你世界</a></h1>
      <div class='banner_title animated zoomIn'>
        <img src="./assets/images/banner_title.png" alt="迷你世界超值移动积分兑">
      </div>
    </div>
    <div class="btn-wraps">
      <div class="exchange-btn2" @click="toExchange">
        <a href="javascript:;">兑换奖励</a>
      </div>
      <div class="btn-rotate" @click="rotateFn">超值抽奖</div>
    </div>
  </div>
  <!--第二部分-->
  <div class='sectionTwo'>
    <div class='section-rules'>
      <section class='main'>
        <h2 class='tx_indent'>道具兑换流程</h2>
        <ul class='tx_indent clearfix'>
          <li>登录迷你账号</li>
          <li @click='showModal'>绑定移动手机号</li>
          <li>通过中国移动短信 兑换冒险勋章 (点击查看兑换方法)</li>
          <li>点击“兑换”获得 想要的道具</li>
        </ul>
        <img src="./assets/images/role.png" alt="">
      </section>
    </div>
    <!--道具部分-->
    <div class='section-items' id="exchange">
      <section class='items-wrap'>
        <ul>
          <li class="first-row">
            <h3 class="tx_indent hot location">热门兑换区</h3>
            <div v-for="(item,i) in goodsList['hot']" :key="i">
              <strong class="sale tx_indent" v-show="item.SrvTotalLimit > -1 && item.Left < 1">已售罄</strong>
              <span class="store" v-show="item.SrvTotalLimit > -1">今日库存：{{item.Left}}</span>
              <p class='top'>冒险勋章：<span>{{item.Honor}}</span></p>
              <img :src="`//mnweb.mini1.cn/game/icons/icon${item.ItemID}.png`">
              <p class='bot'>{{item.Desc}}</p>
              <a href="javascript:;" class='tx_indent' @click='exchangePrize(item)'>立即兑换</a>
            </div>
          </li>
          <li class="second-row">
            <h3 class="tx_indent foruse">生存用品区</h3>
            <div v-for="(item,i) in goodsList['use']" :key="i">
              <p class='top'>冒险勋章：<span>{{item.Honor}}</span></p>
              <img :src="`//mnweb.mini1.cn/game/icons/icon${item.ItemID}.png`">
              <p class='bot'>{{item.Desc}}</p>
              <a href="javascript:;" class='tx_indent' @click='exchangePrize(item)'>立即兑换</a>
            </div>
          </li>
          <li class="third-row">
            <h3 class="tx_indent bank">积分银行</h3>
            <div v-for="(item,i) in goodsList['bank']" :key="i">
              <p class='top'>冒险勋章：<span>{{item.Honor}}</span></p>
              <img :src="`//mnweb.mini1.cn/game/icons/icon${item.ItemID}.png`">
              <p class='bot'>{{item.Desc}}</p>
              <a href="javascript:;" class='tx_indent' @click='exchangePrize(item)'>立即兑换</a>
            </div>
          </li>
          <li class="forth-row" v-show="true">
            <h3 class="tx_indent dress">定制装扮区</h3>
            <span class="morebtn" @click="queryMore(3)">更多</span>
            <div v-for="(item,i) in goodsList['dress']" :key="i">
              <strong class="newitem tx_indent" v-show="item.myadd">新品筹备中</strong>
              <p class='top'>冒险勋章：<span>{{item.Honor}}</span></p>
              <img :src="`//mnweb.mini1.cn/game/icons/icon${item.ItemID}.png`">
              <p class='bot'>{{item.Desc}}</p>
              <a href="javascript:;" class='tx_indent' @click='exchangePrize(item)'>立即兑换</a>
            </div>
          </li>
          <li class="fifth-row">
            <h3 class="tx_indent forever">永久装扮区</h3>
            <span class="morebtn" @click="queryMore(4)">更多</span>
            <div v-for="(item,i) in goodsList['forever']" :key="i">
              <strong class="newitem tx_indent" v-show="item.myadd">新品筹备中</strong>
              <p class='top'>冒险勋章：<span>{{item.Honor}}</span></p>
              <img :src="`//mnweb.mini1.cn/game/icons/icon${item.ItemID}.png`">
              <p class='bot'>{{item.Desc}}</p>
              <a href="javascript:;" class='tx_indent' @click='exchangePrize(item)'>立即兑换</a>
            </div>
          <li class="end-row">
            <h3 class="tx_indent collect">精品典藏区</h3>
            <div v-for="(item,i) in goodsList['collect']" :key="i">
              <strong class="sale tx_indent" v-show="item.Left < 1">已售罄</strong>
              <strong class="newitem tx_indent" v-show="item.myadd">新品筹备中</strong>
              <span class="store">今日库存：{{item.Left}}</span>
              <p class='top'>冒险勋章：<span>{{item.Honor}}</span></p>
              <img :src="`//mnweb.mini1.cn/game/icons/icon${item.ItemID}.png`">
              <p class='bot'>{{item.Desc}}</p>
              <a href="javascript:;" class='tx_indent' @click='exchangePrize(item)'>立即兑换</a>
            </div>
          </li>
        </ul>
      </section>
    </div>
  </div>
  <div class="itemcenter"></div>
  <!--第三部分-->
  <div class='bottom'></div>
  <div id="footer" class="footer" style="height: auto; padding-bottom: 30px;">
    <div class="copyright">Copyright © {{date}} 深圳市迷你玩科技有限公司</div>
  </div>
  <!--登录入口外框-->
  <transition name='fade'>
    <div class='pop' ref='pop' v-show='popLogin'>
      <i class='close' @click='closePop_loginin'></i>
      <section class='pop_main'>
        <!--登录前-->
        <div v-if='!loginStatus' class='login_before' @click='loginIn'>[登录] <span>查询冒险勋章</span></div>
        <!--登录后-->
        <div v-else class='login_after'>
          <div class='top'>
            <img src="./assets/images/tx.png" alt="">
            <p>
              <span>迷你号：{{authinfo.Uin}}</span>
              <el-button type="warning" round size='mini' style='margin-bottom: 5px;margin-left: 10px;' @click='getMedals'>查询冒险勋章</el-button>
              <el-button type='primary' round size='mini' @click='exchangePoint' v-if='false'>兑换勋章</el-button>
              <span>我的冒险勋章：{{honor}}</span>
            </p>
          </div>
          <ul>
            <li @click='getOrder'>【已兑换礼包】</li>
            <li @click='exit'>【注销登录】</li>
            <li @click='bindTel'>【绑定手机号】</li>
            <li @click='showTelList'>【已绑定手机号】</li>
          </ul>
        </div>
        <!--文案-->
        <div class='direction'>
          <h3>勋章相关说明</h3>
          <p style='margin: 10px auto'>• 冒险勋章仅可以使用移动积分进行兑换，具体兑换步骤可以点击下方按钮进行了解。</p>
          <p>• 勋章兑换等待短信通知的过程中，可能由于兑换玩家过多造成一定的延迟，请耐心等待。（如遇延迟，可能需要10~30分钟冒险勋章才能到账）</p>
        </div>
        <button class='tx_indent' @click='showModal'>如何获得冒险勋章</button>
      </section>
    </div>
  </transition>
  <!--冒险勋章兑换方法弹窗  -->
  <Modal :mState='mState' @closeModal='closeM'></Modal>
  <!--登录弹窗-->
  <Login :lState='loginState' @closeLogin='closeL' @success='successFn' @userinfo='getUserInfo'></Login>
  <!--手机号码绑定  -->
  <PhoneModal :tState='bindsTel' @closeTel='closePhone'></PhoneModal>
  <!--绑定手机号列表-->
  <BindPhone :listState='telList' @closeTelList='closeTelList'></BindPhone>
  <!--移动积分兑换勋章入口-->
  <ExchangeModal :exState='exchangeState' @closeExchange='closeExchange'></ExchangeModal>
  <!--已兑换礼包窗口-->
  <MyPackage :mypackage_state='mypackage_state' :goodsList='goodsList' @closeMyPackage='closeMyPackage'></MyPackage>
  <!-- 抽奖 -->
  <Rotate :rotateStatus="rotateStatus" :paramsObj="paramsObj" @closeRotate="closeRotate" @queryXun="queryXun"></Rotate>
  <!-- 点击查询更多框 -->
  <div class="bgpop" v-if="show_more">
    <div class="moreprize_wrap" v-loading="loadings" element-loading-text="拼命加载中..." element-loading-background="rgba(0, 0, 0, 0)">
      <i class="close" @click.stop="closemore"></i>
      <template v-if="!loadings">
        <h3>{{ moretitle }}</h3>
        <p class="bibi">我的冒险勋章：{{ honor }}</p>
        <section class="list-item" v-if="moredata.length">
          <div v-for="(item,i) in moredata" :key="i">
            <strong class="newitem tx_indent" v-show="item.myadd">新品筹备中</strong>
            <p class='top'>冒险勋章：<span>{{item.Honor}}</span></p>
            <img :src="`//mnweb.mini1.cn/game/icons/icon${item.ItemID}.png`">
            <p class='bot'>{{item.Desc}}</p>
            <a href="javascript:;" class='tx_indent' @click='exchangePrize(item,"more")'>立即兑换</a>
          </div>
        </section>
        <section v-else class="nodata">新品筹备中...</section>
      </template>
    </div>
  </div>

</div>
</template>

<script>
import Login from './components/Login'
import Modal from './components/Modal'
import PhoneModal from './components/PhoneModal'
import BindPhone from './components/BindPhone'
import ExchangeModal from './components/ExchangeModal'
import MyPackage from './components/MyPackage'
import goodsList from './components/goodsList';
import Rotate from "./components/Rotate";
export default {
  name: 'App',
  components: {
    Login,
    Modal,
    PhoneModal,
    BindPhone,
    ExchangeModal,
    MyPackage,
    Rotate
  },
  data() {
    return {
      rotateStatus: false, // 抽奖状态
      mState: false, // 兑换方法状态
      popLogin: true, // 悬浮框状态一直显示
      loginState: false, // 登录状态
      loginStatus: false, // 登录后的状态
      bindsTel: false,
      telList: false,
      exchangeState: false, // 移动积分兑换勋章
      mypackage_state: false,
      date: new Date().getFullYear(),
      // 个人信息
      authinfo: {},
      honor: 0, // 勋章
      goodsList: { // 奖项配置
        use: [],
        bank: [],
        dress: [],
        forever: [],
        collect: [],
        hot: []
      },
      moredata: [], // 更多奖项列表（定制装扮|永久装扮）
      show_more: false, // 是否显示更多
      loadings: false, // 默认不显示
      moretitle: "",
      fromclick: "",
      phoneList: [], // 手机号列表
      paramsObj: null
    }
  },
  mounted() {
    // 游戏内进来携带信息
    if (this.getUrlParam(location.href, "uin")) {
      this.getUrlStr();
      let Uin = this.getUrlParam(location.href, "uin"),
        time = this.getUrlParam(location.href, "time"),
        s2t = this.getUrlParam(location.href, "s2t"),
        auth = this.getUrlParam(location.href, "auth");
      this.getToken({
        Uin,
        time,
        s2t,
        auth
      }).then(rel => {
        if (rel.data.code == "OK") {
          let token = rel.data.data;
          this.authinfo = {
            Uin,
            token
          }
          this.loginStatus = true;
          // 登录成功记住账号
          window.sessionStorage.setItem('loginStatus', true)
          window.sessionStorage.setItem('authinfo', JSON.stringify(this.authinfo))
          window.localStorage.setItem('uin', Uin);
          this.getMedal() // 查看冒险勋章
          this.getListGoods() // 获取商品配置列表 
          this.getHot() // 获取热门兑换 
        } else { // 失败
          this.loginStatus = false;
          this.goodsList = goodsList;
        }
      })
    } else { // 没有携带
      if (window.sessionStorage.getItem('loginStatus') == 'true') {
        this.loginStatus = true;
        this.authinfo = JSON.parse(window.sessionStorage.getItem('authinfo'))
        this.paramsObj = this.authinfo;
        this.toLowerCaseFn();
        this.getMedal();
        this.getListGoods();
        this.getHot() // 获取热门兑换
        this.getTelList();
      } else {
        this.loginStatus = false;
        this.goodsList = goodsList;
      }
    }
    window.onscroll = () => {
      if (this.getScrollTop() > 1500) {
        this.$refs.pop.style = "position: absolute;top: 1970px;";
      } else {
        this.$refs.pop.style = "position: fixed;top: 50%;"
      }
    }
  },
  methods: {
    // 关闭更多
    closemore() {
      this.show_more = false;
      this.moretitle = "";
      this.fromclick = "";
    },
    // 查询更多
    queryMore(val) {
      this.fromclick = val;
      if (val == 3) {
        this.moretitle = "定制装扮区";
      } else {
        this.moretitle = "永久装扮区";
      }
      this.show_more = true;
      this.loadings = true;
      this.$http.get('mm/cfg/list_by_groupid', {
        params: {
          token: this.authinfo.token,
          groupid: val
        }
      }).then(rel => {

        console.log(rel)
        if (rel.status == 200) {
          this.moredata = rel.data[1];
          this.loadings = false;
        } else {
          this.loadings = false;
          this.$message({
            type: 'error',
            message: '服务出错'
          });
        }
      }).catch(e => {
        this.loadings = false;
        this.$message({
          type: 'error',
          message: '服务出错'
        });
      })
    },
    toExchange() {
      window.scrollTo({
        top: 1200,
        behavior: "smooth"
      });
    },
    queryXun(val) {
      this.$http.get('mm/honor/query', {
        params: {
          token: this.authinfo.token
        }
      }).then(rel => {
        if (rel.data.code == 'OK') {
          this.honor = rel.data.data.Honor;
        }
      })
    },
    closeRotate(val) {
      this.rotateStatus = val;
    },
    // 抽奖弹窗
    rotateFn() {
      if (!this.loginStatus) {
        this.loginIn()
      } else {
        this.rotateStatus = true;
      }

    },
    // 获取token
    getToken(params) {
      return this.$http.get('mm/token', {
        params
      })
    },
    // 获取连接附带的信息
    getUrlParam(url, parm) {
      let reg = new RegExp("(^|&)" + parm + "=([^&]*)(&|$)");
      let r = url.substr(url.indexOf("\?") + 1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    getScrollTop() {
      let scroll_top = 0;
      if (document.documentElement && document.documentElement.scrollTop) {
        scroll_top = document.documentElement.scrollTop;
      } else if (document.body) {
        scroll_top = document.body.scrollTop;
      }
      return scroll_top;
    },
    // 弹出兑换弹窗
    showModal() {
      this.mState = true
    },
    // 关闭兑换弹窗
    closeM(val) {
      this.mState = val
    },
    // 关闭悬浮登录入口
    closePop_loginin() {
      this.popLogin = false
    },
    // 显示悬浮登录入口
    showPoplogin() {
      this.popLogin = true
    },
    // 登录弹窗
    loginIn() {
      alert("维护中...")
      // this.loginState = true
    },
    // 关闭登录弹窗
    closeL(val) {
      this.loginState = val
    },
    // 登录成功
    successFn(val) {
      this.loginStatus = val;
    },
    getUserInfo(val) {
      this.authinfo = val;
      this.paramsObj = val;
      this.toLowerCaseFn();
      console.log(this.paramsObj)
      this.getMedal() // 查看冒险勋章
      this.getListGoods() // 获取商品配置列表
      this.getHot() // 获取热门兑换
    },
    toLowerCaseFn() {
      if (this.paramsObj) {
        let lowerObj = {};
        for (let key in this.paramsObj) {
          let val = this.paramsObj[key];
          key = key.toLowerCase();
          lowerObj[key] = val
        }
        this.paramsObj = lowerObj;
      }
    },
    // 注销
    exit() {
      this.$confirm('确定退出?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loginStatus = false;
        this.authinfo = {};
        this.honor = -1;
        this.goodsList = goodsList;
        window.sessionStorage.removeItem('authinfo');
        window.sessionStorage.setItem('loginStatus', false)
        this.$message({
          type: 'success',
          message: '退出成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    // 查询冒险勋章
    getMedals() {
      this.getTelList(); // 先查询手机号
      this.getMedal2(); // 在去确认
      this.getMedal(); // 最后查询兑换
    },
    // 查询勋章 
    getMedal() {
      this.$http.get('mm/honor/query', {
        params: {
          token: this.authinfo.token
        }
      }).then(rel => {
        if (rel.data.code == 'OK') {
          if (this.honor == rel.data.data.Honor) {
            this.$message({
              message: '当前已显示所有冒险勋章了',
              type: 'warning'
            });
          } else {
            this.honor = rel.data.data.Honor;
          }
        }
      })
    },
    // 获取手机号列表
    getTelList() {
      this.$http.get('mm/bind/list', {
        params: {
          token: this.authinfo.token
        }
      }).then(rel => {
        if (rel.data.code == 'OK') {
          this.phoneList = rel.data.data;
        }
      })
    },
    // 兑换完成，发送确认兑换接口
    getMedal2() {
      if (this.phoneList.length) {
        this.$http.get('mm/consume', {
          params: {
            token: this.authinfo.token,
            phone: this.phoneList.join('|')
          }
        }).then(rel => {

        })
      }
    },
    // 获取热门
    getHot() {
      this.$http.get('/mm/cfg/hot', {
        params: {
          token: this.authinfo.token
        }
      }).then(rel => {
        if (rel.status == 200) {
          this.goodsList.hot = rel.data.data;
        }
      })
    },
    // 获取商品配置列表
    getListGoods() {
      this.$http.get('mm/cfg/list', {
        params: {
          token: this.authinfo.token,
          _time: new Date().getTime()
        }
      }).then(rel => {
        if (rel.status == 200) {
          if (Array.isArray(rel.data[1])) {
            const listArr = rel.data[1];
            // 生存用品区 第一栏
            let arr1 = listArr.filter(val => {
              return val.exGourpID == 1;
            })
            let arr2 = listArr.filter(val => {
              return val.exGourpID == 2;
            })
            let arr3 = listArr.filter(val => {
              return val.exGourpID == 3;
            })
            let arr4 = listArr.filter(val => {
              return val.exGourpID == 4;
            })
            let arr5 = listArr.filter(val => {
              return val.exGourpID == 5;
            })

            for (let i = 0; i < 3; i++) {
              if (arr3.length < 3) {
                arr3.push({
                  Desc: "???",
                  Honor: "???",
                  Left: "???",
                  myadd: "1",
                  ItemID: "placeholder"
                })
              }
              if (arr4.length < 3) {
                arr4.push({
                  Desc: "???",
                  Honor: "???",
                  Left: "???",
                  myadd: "1",
                  ItemID: "placeholder"
                })
              }
              if (arr5.length < 3) {
                arr5.push({
                  Desc: "???",
                  Honor: "???",
                  Left: "???",
                  myadd: 1,
                  ItemID: "placeholder"
                })
              }
            }
            this.goodsList.use = arr1;
            this.goodsList.bank = arr2;
            this.goodsList.dress = arr3;
            this.goodsList.forever = arr4;
            this.goodsList.collect = arr5;
          } else {
            this.goodsList = [];
          }
        }
      })
    },
    // 关闭手机弹窗
    closePhone(val) {
      this.bindsTel = val
    },
    // 绑定手机号
    bindTel() {
      this.bindsTel = true
    },
    // 已绑定手机号列表弹窗
    showTelList() {
      this.telList = true
    },
    // 关闭手机号列表弹窗
    closeTelList(val) {
      this.telList = val
    },
    // 移动积分兑换勋章入口
    exchangePoint() {
      this.exchangeState = true
    },
    closeExchange(val) {
      this.exchangeState = val
    },
    // 兑换
    exchangePrize(item, val) {
      // 如果未登录点击弹出登录框
      if (!this.loginStatus) {
        this.loginIn()
      } else {
        this.$confirm(`是否消耗${item.Honor}冒险勋章兑换【${item.Desc}】?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.get('mm/honor/exchange', {
            params: {
              token: this.authinfo.token,
              ID: item.ID,
              BonusID: item.BonusID
            }
          }).then(rel => {
            if (rel.data.code == 'OK') {
              this.$message({
                message: `兑换成功，已扣除${item.Honor}冒险勋章，兑换道具已通过邮件发送到游戏内邮箱，请登录游戏领取！`,
                type: 'success',
                duration: 5000,
                showClose: true
              });
              console.log(val)
              if (val == "more") {
                this.queryMore(this.fromclick)
              } else {
                
                this.getHot() // 获取热门兑换
              }
              this.getListGoods() // 刷新列表
              this.getMedal() // 实时更新冒险勋章

            }
            if (rel.data.code == 'FAILED') {
              // this.$message.error(rel.data.msg);
              this.$message.error("冒险勋章不足");
            }

          })
        }).catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消'
          // });
        });
      }
    },
    // 查询已兑换礼包
    getOrder() {
      this.mypackage_state = true
    },
    // 关闭查询已兑换礼包窗口
    closeMyPackage(val) {
      this.mypackage_state = val
    },
    getUrlStr() {
      var obj = this.parseQueryString(location.href);
      this.paramsObj = obj;
    },
    // 将url ? 键值对转为json对象
    parseQueryString(url) {
      var reg_url = /^[^\?]+\?([\w\W]+)$/,
        reg_para = /([^&=]+)=([\w\W]*?)(&|$|#)/g,
        arr_url = reg_url.exec(url),
        ret = {};
      if (arr_url && arr_url[1]) {
        var str_para = arr_url[1],
          result;
        while ((result = reg_para.exec(str_para)) != null) {
          ret[result[1]] = result[2];
        }
      }
      return ret;
    }
  }

}
</script>

<style lang="scss">
@import "./assets/css/animation.css";

/* 默认样式初始化 */
body,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
p,
blockquote,
dl,
dt,
dd,
ul,
ol,
li,
pre,
form,
fieldset,
legend,
button,
input,
textarea,
th,
td {
  margin: 0;
  padding: 0;
}

body,
button,
input,
select,
textarea {
  font: 16px/1.5 Microsoft YaHei;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 100%;
}

address,
cite,
dfn,
em,
var {
  font-style: normal;
}

code,
kbd,
pre,
samp {
  font-family: couriernew, courier, monospace;
}

small {
  font-size: 12px;
}

ul,
ol {
  list-style: none;
}

a {
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

sup {
  vertical-align: text-top;
}

sub {
  vertical-align: text-bottom;
}

legend {
  color: #000;
}

fieldset,
img {
  border: 0;
}

button,
input,
select,
textarea {
  font-size: 100%;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

body {
  min-width: 1200px;
}

.tx_indent {
  text-indent: -2000px;
  overflow: hidden;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.clearfix:after {
  content: '';
  display: block;
  clear: both;
}

.clearfix {
  zoom: 1;
}

#app {

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  .main {
    width: 1100px;
    margin: auto;
  }

  .btn-wraps {
    position: relative;
    z-index: 999;
    width: 600px;
    height: 120px;
    margin: auto;
    display: flex;
    justify-content: space-between;

    .exchange-btn2,
    .btn-rotate {
      width: 280px;
      height: 114px;
      background: url("./assets/images/login_btn.png") no-repeat center;
      cursor: pointer;
      text-align: center;
      line-height: 114px;
      color: #fff;
      font-size: 30px;

      a {
        color: #fff;

        &:hover {
          text-decoration: none;
        }
      }
    }
  }

  .banner {
    height: 750px;
    background: url("./assets/images/banner.jpg") no-repeat center top;

    h1 {
      position: relative;
      left: -32px;
      width: 209px;
      height: 76px;
      background: url("./assets/images/logo.png") no-repeat;
      transition: all 0.5s ease;
      transform: translateY(-8px);

      &:hover {
        transform: translateY(0px);
      }

      a {
        display: block;
        height: 100%;
        cursor: default;
      }
    }

    .banner_title {
      width: 885px;
      height: 353px;
      margin: 290px auto 0;

      img {
        display: block;
      }
    }
  }

  .sectionTwo {
    height: 1207px;
    padding-top: 96px;
    background: url("./assets/images/bg2.jpg") no-repeat center top;

    .section-rules {
      .main {
        position: relative;
      }

      h2 {
        width: 249px;
        height: 48px;
        margin-left: 55px;
        margin-bottom: 17px;
        background: url("./assets/images/rule-font.png") no-repeat;
      }

      ul {
        width: 911px;
        height: 218px;
        margin-left: 45px;
        padding-top: 20px;
        background: url("./assets/images/rules.png") no-repeat;

        li {
          float: left;
          width: 175px;
          height: 200px;
          margin: 0 26px;

          &:nth-child(2) {
            cursor: pointer;
          }
        }
      }

      img {
        position: absolute;
        right: -80px;
        top: -100px;
      }
    }

    .section-items {
      position: relative;
      width: 1079px;
      height: 1790px;
      margin: 80px auto 0;
      background: url("./assets/images/propsbg.png") no-repeat center top;
      z-index: 999;

      &>a {
        position: absolute;
        top: 50%;
        left: 90px;
        width: 172px;
        height: 65px;
        margin-top: 30px;
      }

      .items-wrap {
        ul {
          padding-left: 356px;
          padding-top: 40px;

          li {
            width: 685px;
            height: 275px;
            background: url("./assets/images/item_plusbg.png") no-repeat top center;

            .location {
              position: absolute;
              top: -40px;
              left: 50%;
            }

            &.first-row {
              position: relative;
              padding-top: 40px;
              height: 215px;
              padding-left: 5px;
              width: 680px;

              .hot {
                width: 272px;
                height: 68px;
                margin-left: -135px;
                background: url("./assets/images/hot.png") no-repeat center;
              }
            }

            &.second-row,
            &.third-row,
            &.forth-row,
            &.fifth-row,
            &.end-row {
              position: relative;
              margin-top: 45px;
              padding-top: 25px;
              height: 215px;
              padding-left: 100px;
              width: 585px;
              border-radius: 10px;

              .foruse {
                position: absolute;
                top: -33px;
                left: 0;
                width: 226px;
                height: 46px;
                background: url("./assets/images/foruse.png") no-repeat center;
              }

              .bank {
                position: absolute;
                top: -33px;
                left: 0;
                width: 201px;
                height: 46px;
                background: url("./assets/images/bank.png") no-repeat center;
              }

              .dress {
                position: absolute;
                top: -33px;
                left: 0;
                width: 229px;
                height: 46px;
                background: url("./assets/images/dress.png") no-repeat center;

              }

              .forever {
                position: absolute;
                top: -33px;
                left: 0;
                width: 227px;
                height: 46px;
                background: url("./assets/images/forever.png") no-repeat center;
              }

              .collect {
                position: absolute;
                top: -33px;
                left: 0;
                width: 205px;
                height: 46px;
                background: url("./assets/images/collect.png") no-repeat center;
              }

              .sale,
              .newitem {
                position: absolute;
                left: -5px;
                top: -40px;
                width: 138px;
                height: 240px;
                background: rgba(0, 0, 0, .4);
                z-index: 999;
                border-radius: 15px;

                &::after {
                  content: "";
                  position: absolute;
                  top: 52px;
                  left: 0;
                  width: 130px;
                  height: 89px;
                  background: url("./assets/images/sale.png") no-repeat center;
                }

              }

              .newitem {
                &::after {
                  top: 70px;
                  left: 5px;
                  height: 90px;
                  background: url("./assets/images/newicon.png") no-repeat center;
                }
              }

              .morebtn {
                position: absolute;
                z-index: 2;
                right: 10px;
                top: -30px;
                width: 99px;
                height: 33px;
                font-size: 0;
                cursor: pointer;
                background: url("./assets/images/morebtn.png") no-repeat center;
              }
            }

            &.fifth-row {
              .newitem {
                top: -5px;
                height: 210px;

                &::after {
                  top: 45px;
                  left: 5px;
                  height: 90px;
                  background: url("./assets/images/newicon.png") no-repeat center;
                }
              }
            }

            &.forth-row {
              .newitem {
                top: -8px;
                height: 210px;

                &::after {
                  top: 39px;

                }
              }
            }

            &.end-row {
              height: 215px;
              padding-top: 60px;
            }
          }

        }

        div {
          position: relative;
          width: 128px;
          display: inline-block;
          background: #fff;
          padding-bottom: 7px;
          border-width: 2px;
          border-color: #baa66a;
          border-style: solid;
          border-radius: 8px;
          margin: 0 14px;
          background-color: rgb(255, 255, 255);
          box-shadow: 0px 10px 10px rgba(73, 119, 38, 0.4);
          height: 140px;
          text-align: center;

          .store {
            border: 2px solid rgb(186, 166, 106);
            border-radius: 8px;
            background-color: rgb(61, 44, 34);
            position: absolute;
            left: 0;
            top: -39px;
            width: 128px;
            height: 28px;
            font-size: 14px;
            color: #d9c27e;
            text-align: center;
            line-height: 28px;
            white-space: nowrap;

            &::after,
            &::before {
              position: absolute;
              bottom: -16px;
              content: "";
              width: 4px;
              height: 17px;
              border-radius: 5px;
              background: #ddc976;
            }
          }

          .bot {
            width: 100%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 14px;
          }

          .top {
            border-radius: 5px 5px 0 0;
            padding: 0 6px;
            font-size: 14px;
            line-height: 32px;
            background: #b4682a;
            color: #fff;

            span {
              color: #ffe200;
            }
          }

          img {
            display: block;
            width: 80px;
            height: 80px;
            margin: 3px auto 4px;
            border-radius: 5px;
            background-color: rgb(66, 66, 66);
          }

          a {
            position: relative;
            left: -5px;
            display: block;
            width: 138px;
            height: 44px;
            margin: 16px auto;
            background: url("./assets/images/exchange.png") no-repeat;
          }
        }
      }
    }
  }

  .itemcenter {
    position: relative;
    z-index: 99;
    height: 1105px;
    background: url("./assets/images/bgcenter.jpg") no-repeat center top;
  }

  .bottom {
    position: relative;
    margin-top: -144px;
    height: 1327px;
    background: url("./assets/images/bottom.jpg") no-repeat center top;
  }

  #footer {
    background-color: #000;
    padding-top: 40px;
    text-align: center;
    color: #fff;

  }

  .pop {
    position: fixed;
    top: 50%;
    left: 57px;
    width: 351px;
    height: 540px;
    margin-top: -280px;
    background: url("./assets/images/login_pop.png") no-repeat;
    z-index: 999;

    .close {
      display: none;
      position: absolute;
      width: 60px;
      height: 60px;
      background: url("./assets/images/close.png") no-repeat;
      transition: 0.3s;
      cursor: pointer;
      left: 50%;
      margin-left: -30px;
      top: -54px;

      &:hover {
        transform: rotate(360deg);
        transition: .3s;
      }
    }

    .tx_indent {
      opacity: 0;
      position: absolute;
      bottom: 50px;
      left: 50%;
      margin-left: -90px;
      width: 180px;
      height: 60px;
      cursor: pointer;
    }

    .login_before {
      position: absolute;
      top: 36px;
      left: 50%;
      width: 280px;
      height: 114px;
      text-align: center;
      line-height: 114px;
      margin-left: -140px;
      background: url("./assets/images/login_btn.png") no-repeat;
      color: #fff;
      font-size: 22px;
      cursor: pointer;

      span {
        color: #4d2517;
      }
    }

    .login_after {
      position: absolute;
      top: 30px;
      left: 50%;
      margin-left: -150px;
      width: 303px;
      font-size: 14px;
      color: #424242;
      font-weight: bold;

      .top {
        height: 83px;
        border-bottom: 1px dashed #9b9b9b;

        img {
          float: left;
          border-radius: 5px;
          width: 77px;
          height: 77px;
          margin-left: 8px;
        }

        p {
          width: 224px;
          padding-left: 95px;
          line-height: 24px;

          span {
            position: relative;
            display: block;
          }
        }
      }

      ul {
        padding-left: 28px;
        color: #3172b3;

        li {
          width: 120px;
          text-align: center;
          display: inline-block;
          cursor: pointer;
          margin: 3px 0;
        }
      }
    }

    .direction {
      width: 300px;
      margin: auto;
      padding-top: 182px;

      h3 {
        font-size: 22px;
        text-align: center;

        &:after,
        &:before {
          content: "";
          display: inline-block;
          width: 17px;
          height: 17px;
          margin: 0 3px;
          background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARBAMAAADJQ1rJAAAAG1BMVEUAAACgoKCgoKCgoKBBUXOgoKCgoKBBUXNBUXPpvIDpAAAACHRSTlMAD2Uuc1lKM8jG8RAAAABNSURBVAjXYwACxkAGKBBKEoAwGJWZFaFCBgVGAhAhlhagIFjIo8MBKAgS6ugACkKEOsCCYewdQNDOFoAQQ6hD6EWYh7ADYS/CLQj3AQAUkBVPJ+i81QAAAABJRU5ErkJggg==) no-repeat;
        }
      }

      p {
        font-size: 14px;
        width: 230px;
        margin: auto;
        line-height: 26px;
      }
    }
  }

  .bgpop {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .5);

    .loading {
      display: block;
      padding-top: 20px;
      color: #6f4027;
      font-size: 20px;
      text-align: center;
    }
    .nodata {
      margin-top: 200px;
      font-size: 38px;
      font-weight: bold;
      color: #6f4027;
      text-align: center;
    }
    h3 {
      text-align: center;
      color: #6f4027;
      font-size: 38px;
      font-weight: bold;
    }

    .bibi {
      font-size: 20px;
      color: #6f4027;
      text-align: center;
      margin-bottom: 20px;
    }

    .moreprize_wrap {
      position: absolute;
      left: 50%;
      top: 50%;
      width: 926px;
      height: 830px;
      padding-top: 40px;
      margin-left: -463px;
      margin-top: -435px;
      background: url("./assets/images/popbp.png") no-repeat center;

      .close {
        position: absolute;
        right: 0;
        top: 0;
        width: 60px;
        height: 60px;
        background: url("./assets/images/close2.png") no-repeat center;
        cursor: pointer;
      }

      .list-item {
        width: 675px;
        margin: auto;
        height: 655px;
        overflow-y: auto;

        &::-webkit-scrollbar {
          width: 10px;
          height: 700px;
          background-color: #f5f5f5;
        }

        &::-webkit-scrollbar-thumb {
          width: 10px;
          border-radius: 8px;
          background: #b4682a;
        }

        div {
          position: relative;
          width: 128px;
          display: inline-block;
          background: #fff;
          padding-bottom: 7px;
          border-width: 2px;
          border-color: #baa66a;
          border-style: solid;
          border-radius: 8px;
          margin: 0 14px;
          background-color: rgb(255, 255, 255);
          box-shadow: 0px 10px 10px rgba(73, 119, 38, 0.4);
          height: 140px;
          text-align: center;

          .store {
            border: 2px solid rgb(186, 166, 106);
            border-radius: 8px;
            background-color: rgb(61, 44, 34);
            position: absolute;
            left: 0;
            top: -39px;
            width: 128px;
            height: 28px;
            font-size: 14px;
            color: #d9c27e;
            text-align: center;
            line-height: 28px;
            white-space: nowrap;

            &::after,
            &::before {
              position: absolute;
              bottom: -16px;
              content: "";
              width: 4px;
              height: 17px;
              border-radius: 5px;
              background: #ddc976;
            }
          }

          .bot {
            width: 100%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 14px;
          }

          .top {
            border-radius: 5px 5px 0 0;
            padding: 0 6px;
            font-size: 14px;
            line-height: 32px;
            background: #b4682a;
            color: #fff;

            span {
              color: #ffe200;
            }
          }

          img {
            display: block;
            width: 80px;
            height: 80px;
            margin: 3px auto 4px;
            border-radius: 5px;
            background-color: rgb(66, 66, 66);
          }

          a {
            position: relative;
            left: -5px;
            display: block;
            width: 138px;
            height: 44px;
            margin: 16px auto;
            background: url("./assets/images/exchange.png") no-repeat;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue